import { Injectable, inject } from '@angular/core';
import { Plugin, PluginService } from '@jeppesen-foreflight/jmkw-types';
import { NGXLogger } from 'ngx-logger';
import { Observable, forkJoin, map } from 'rxjs';
import { CulturalPluginService } from './plugins/cultural/cultural.plugin.service';
import { NavigationPluginService } from './plugins/navigation/navigation.plugin.service';
import { ObstaclesPluginService } from './plugins/obstacles/obstacles.plugin.service';

@Injectable({ providedIn: 'root' })
export class AviationPluginService implements PluginService {
  id = 'aviation' as const;

  private readonly _logger = inject(NGXLogger);
  private readonly _culturalSvc = inject(CulturalPluginService);
  private readonly _navPluginSvc = inject(NavigationPluginService);
  private readonly _obstaclesPluginSvc = inject(ObstaclesPluginService);

  create(): Observable<Plugin> {
    this._logger.trace('[AviationPluginService] create() called');
    return forkJoin({
      cultural: this._culturalSvc.create(),
      navigation: this._navPluginSvc.create(),
      obstacles: this._obstaclesPluginSvc.create()
    }).pipe(
      map(({ cultural, navigation, obstacles }) => {
        this._logger.trace('[AviationPluginService] All child plugins created:', {
          cultural: cultural.id,
          navigation: navigation.id,
          obstacles: obstacles.id
        });
        return new Plugin({
          id: 'aviation',
          children: [cultural, navigation, obstacles]
        });
      })
    );
  }
}
